import React from 'react'
import dayjs from 'dayjs'
import { Card, Image, Typography } from 'antd'
import { Icon } from '@iconify/react'

import styles from './InspirationCard.module.css'

const { Text } = Typography

const InspirationCard = ({ item, onOpen }) => {
    const isMobile =
        String(item?.platform || '')
            .trim()
            .toLowerCase() === 'mobile'
    const categoryLabel = item?.category?.name || 'Uncategorized'
    const title = item?.projectTitle || 'Untitled gallery'
    const subtitle = item?.tagline || categoryLabel

    return (
        <Card
            className={`${styles.galleryCard}${
                isMobile ? ` ${styles.galleryCardMobile}` : ''
            }`}
            hoverable={false}
            onClick={() => onOpen?.(item)}
        >
            <div className={styles.cardContent}>
                {item?.projectFeatureImage ? (
                    isMobile ? (
                        <div className={styles.mobilePreview}>
                            <div className={styles.mobilePreviewInner}>
                                <div className={styles.phoneFrame}>
                                    <div className={styles.phoneScreen}>
                                        <Image
                                            src={item.projectFeatureImage}
                                            preview={false}
                                            alt=""
                                            className={styles.previewImage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div className={styles.webPreview}>
                            <Image
                                src={item.projectFeatureImage}
                                preview={false}
                                alt=""
                                className={styles.previewImage}
                            />
                        </div>
                    )
                ) : (
                    <div
                        className={
                            isMobile
                                ? styles.mobilePreviewEmpty
                                : styles.webPreviewEmpty
                        }
                    >
                        <Icon
                            icon={
                                isMobile ? 'mdi:cellphone' : 'mdi:monitor'
                            }
                            width={28}
                            height={28}
                        />
                    </div>
                )}

                <div className={styles.cardHeader}>
                    {item?.projectLogo ? (
                        <div className={styles.logoWrap}>
                            <Image
                                src={item.projectLogo}
                                preview={false}
                                alt=""
                                className={styles.logoImage}
                            />
                        </div>
                    ) : (
                        <div className={styles.logoWrap}>
                            <Icon
                                icon={
                                    isMobile
                                        ? 'mdi:cellphone'
                                        : 'mdi:monitor'
                                }
                                width={22}
                                height={22}
                            />
                        </div>
                    )}
                    <div className={styles.galleryInfo}>
                        <Text className={styles.galleryTitle} title={title}>
                            {title}
                        </Text>
                        <Text
                            className={styles.gallerySubtitle}
                            title={subtitle}
                        >
                            {subtitle}
                        </Text>
                    </div>
                </div>

                <div className={styles.detailsSection}>
                    <div className={styles.metaBlock}>
                        <div className={styles.metaHeader}>
                            <Icon
                                icon="mdi:tag-outline"
                                className={styles.metaIcon}
                            />
                            <span className={styles.metaLabel}>Category</span>
                        </div>
                        <Text
                            className={styles.metaValue}
                            title={categoryLabel}
                        >
                            {categoryLabel}
                        </Text>
                    </div>
                    <div className={styles.metaBlock}>
                        <div className={styles.metaHeader}>
                            <Icon
                                icon="mdi:calendar-outline"
                                className={styles.metaIcon}
                            />
                            <span className={styles.metaLabel}>Created</span>
                        </div>
                        <Text className={styles.metaValue}>
                            {item?.createdAt
                                ? dayjs(item.createdAt).format('DD MMM YYYY')
                                : 'N/A'}
                        </Text>
                    </div>
                </div>
            </div>
        </Card>
    )
}

export default InspirationCard
